/* Group template ID for Backoffice managers */
export const BACKOFFICE_MANAGER_GT_ID = 28;

/* User facing template ID for Backoffice managers */
export const BACKOFFICE_MANAGER_UFT_ID = 4;

/* Group template ID for multi-site managers */
export const MULTISITE_MANAGER_GT_ID = 27;

/* User facing template ID for multi-site managers */
export const MULTISITE_MANAGER_UFT_ID = 3;

/* Group template IDs for pocket-lab users */
export const POCKETLAB_GT_IDS = [24, 25];

/* User facing template ID for pocket-lab users */
export const POCKETLAB_UFT_ID = 1;
